import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { audiencePaths } from "@/data/services";

export default function AudiencePaths() {
  return (
    <section className="bg-white text-brand-black" data-testid="audience-paths">
      <div className="mx-auto max-w-[1360px] px-5 md:px-10 py-24 md:py-28">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-6">
            <div className="eyebrow-accent">Who this is for</div>
            <h2 className="mt-4 text-[32px] md:text-5xl font-bold tracking-tight leading-[1.06]">
              Built primarily for real estate professionals, with clear paths for other property owners.
            </h2>
          </div>
          <p className="lg:col-span-6 text-[15.5px] leading-relaxed text-brand-gray max-w-xl">
            LotWise Home is a B2B service. Real estate agents, teams, and brokerages are the primary
            audience. Builders, developers, investors, and property owners can also use LotWise Home
            for the same managed process on their own properties.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {audiencePaths.map((a, i) => (
            <Link
              key={a.slug}
              to={`/contact?audience=${a.slug}`}
              data-testid={`audience-card-${a.slug}`}
              className="group flex flex-col justify-between border border-brand-gray/25 p-5 md:p-6 bg-white hover:border-brand-black transition-colors"
            >
              <div>
                <div className="text-[10px] tracking-[0.22em] uppercase text-brand-gray">Path {String(i + 1).padStart(2, "0")}</div>
                <h3 className="mt-4 text-[19px] md:text-[20px] font-bold tracking-tight leading-snug">{a.label}</h3>
                <p className="mt-3 text-[13.5px] leading-relaxed text-brand-gray">{a.intro}</p>
              </div>
              <div className="mt-6 pt-4 border-t border-brand-gray/20 flex items-center justify-between text-[11px] tracking-[0.18em] uppercase text-brand-gray group-hover:text-brand-black transition-colors">
                <span>{a.ctaLabel}</span>
                <ArrowUpRight className="h-4 w-4 text-brand-black transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
